import type { AxiosError } from 'axios'
import useSyncStore from '@/store/SyncStore'

export const isNetworkError = (error: unknown): boolean => {
  const err = error as AxiosError | undefined
  if (!err) return false
  if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED') return true
  if (err.message === 'Network Error') return true
  return err.response === undefined && err.request !== undefined
}

const PROBE_TIMEOUT_MS = 4000

export const probeApiReachable = async (): Promise<boolean> => {
  const baseUrl = import.meta.env.VITE_MOLY_API
  if (!baseUrl) return false

  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS)

  try {
    await fetch(baseUrl, {
      method: 'HEAD',
      mode: 'no-cors',
      signal: controller.signal,
      cache: 'no-store',
    })
    return true
  } catch {
    return false
  } finally {
    clearTimeout(timeout)
  }
}

export const markApiHealthy = () => {
  const store = useSyncStore.getState()
  if (store.apiStatus !== 'healthy') {
    store.setApiStatus('healthy')
  }
}

export const markApiDown = () => {
  const store = useSyncStore.getState()
  if (store.apiStatus !== 'down') {
    store.setApiStatus('down')
  }
}
